/**
 * The weekly gift's link from a Facebook post: `?gift=box` (a gift to open)
 * or `?gift=wheel` (a wheel to spin). Any other value opens the box.
 */
export type GiftLinkStyle = 'box' | 'wheel';

/** The style a gift link asks for, or null with no gift in the address. */
export function readGiftLink(search: string = window.location.search): GiftLinkStyle | null {
  const value = new URLSearchParams(search).get('gift');
  if (value === null) return null;
  return value.toLowerCase() === 'wheel' ? 'wheel' : 'box';
}

/** Take the gift out of the address, so a reload doesn't offer it again. */
export function clearGiftLink(): void {
  const url = new URL(window.location.href);
  if (!url.searchParams.has('gift')) return;
  url.searchParams.delete('gift');
  window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
}
